import { lonLatFor, projectLonLat } from '@/components/value-chain/starlinkIsoCoords';
import type { StarlinkMarket } from '@/components/value-chain/starlinkMarkets';

const W = 640;
const H = 300;

const FILL: Record<string, string> = {
  live: '#34d399',
  coming_soon: '#60a5fa',
  pending: '#38bdf8',
  blocked: '#64748b',
  unknown: '#334155',
};

export function StarlinkFootprintMap({ markets }: { markets: StarlinkMarket[] }) {
  const dots = markets
    .filter((market) => market.status_bucket !== 'unknown')
    .map((market) => {
      const [lon, lat] = lonLatFor(market.iso2, market.region);
      const [x, y] = projectLonLat(lon, lat, W, H);
      return { ...market, x, y };
    })
    .filter((dot) => dot.x > 8 && dot.x < W - 8 && dot.y > 8 && dot.y < H - 8);

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="h-full w-full" role="img" aria-label="Starlink market footprint">
      <rect width={W} height={H} fill="#08233d" rx="12" />
      <Continents />
      {dots.map((dot) => (
        <circle
          key={dot.iso2}
          cx={dot.x}
          cy={dot.y}
          r={dot.status_bucket === 'live' ? 2.4 : 1.8}
          fill={FILL[dot.status_bucket] ?? FILL.unknown}
          opacity={dot.status_bucket === 'live' ? 0.92 : 0.7}
        >
          <title>{`${dot.name} · ${dot.status_bucket.replace('_', ' ')}`}</title>
        </circle>
      ))}
    </svg>
  );
}

function Continents() {
  return (
    <g fill="#16385a" stroke="#1e4a73" strokeWidth="0.6">
      <path d="M78 78c18-22 48-28 78-18 22 8 38 6 52-8 10 18-2 38-22 46-28 12-62 8-86-4-14-8-24-8-22-16z" />
      <path d="M118 108c28 4 48 28 38 58-8 22-32 38-54 34-24-4-40-28-34-50 4-16 24-32 50-42z" />
      <path d="M268 62c22-18 48-16 62 4 18 24 8 48-10 58-22 12-46 4-58-14-8-14-4-32 6-48z" />
      <path d="M292 118c8 18 6 42-8 58-12 14-8 32 8 38 10-18 28-16 34 2 6 22-12 40-32 44-28 6-54-18-50-46 2-22 18-48 48-96z" />
      <path d="M348 70c40-8 78 4 118 28 28 18 62 14 88-6 8 22-10 40-34 46-32 8-58 28-52 52 18 8 14 28-6 32-36 8-78-22-108-18-22 2-40-18-36-38 6-22 8-72 30-96z" />
      <path d="M508 198c18-8 38-4 48 12 8 14 4 28-10 32-18 4-36-8-42-22-4-10 0-18 4-22z" />
      <path d="M148 228c22 8 18 28 2 38-16 8-32-4-30-18 2-10 14-22 28-20z" />
    </g>
  );
}
